/// <reference path="appbase.ts" />

namespace TerminalApp {
    export class login extends AppBase {
        constructor() {
            super("login");
            document.getElementById("login_button").onclick = () => {
                this.LogIn();
            }
        }

        async LogIn() {
            var result = await SP.postForm("/API/FormSubmit/Login", "#login_form");
            if (result == true) {
                GetApp("homescreen").open();
                location.reload();
            }
            else {
                document.getElementById("login_error").style.display = "block";
            }
        }


        bound = false;
        async onOpen() {
            (document.querySelector(".top") as HTMLElement).style.display = "none";

            if (!this.bound) {
                this.bound = true;
            }

        }

        async scanLoginToken(token: string) {

        }

        async onClose() {
            (document.querySelector(".top") as HTMLElement).style.display = "block";

            if (this.bound) {
                barcodeListener.on("lt", this.scanLoginToken, this);
                this.bound = false;

            }
        }
    }


    RegisterApp("login", login);
}